// extracted by mini-css-extract-plugin
export default {"divider":"QuickAssignControls_divider__yw160","controls":"QuickAssignControls_controls__BvLuI"};